import { getDateForDatePicker } from '@/util'

export default {
  data () {
    return {
      page: 1
    }
  },
  computed: {
    timezone () {
      return this.$store.getters['account/timezone']
    },
  },

  mounted () {
    this.filters.farm = this.$route.params.farm_id
    const today = getDateForDatePicker(this.timezone)
    this.filters.planned_on_before = today
    this.filters.planned_on_after = today
  },

  watch: {
    filters: {
      handler () {
        this.page = 1
        this.loadData()
      },
      deep: true
    },
    timezone (newTimezone) {
    },
  }
}
